import { render, staticRenderFns } from "./culturalCollection.vue?vue&type=template&id=78d22436&scoped=true"
import script from "./culturalCollection.vue?vue&type=script&lang=js"
export * from "./culturalCollection.vue?vue&type=script&lang=js"
import style0 from "./culturalCollection.vue?vue&type=style&index=0&id=78d22436&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d22436",
  null
  
)

export default component.exports